// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails";
import "@github/relative-time-element";
import ahoy from "ahoy.js";
import "$js/channels";
import "$js/turbostream/index.js";
import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();

// Trix/ActionText
import "trix";
import "@rails/actiontext";

import "$js/controllers/index.js";

// Event handlers
document.addEventListener("turbo:load", function () {
  document.addEventListener('click', function(e) {
    if (e.target.matches('.force-target-blank .trix-content a')) {
      e.target.setAttribute('target', '_blank');
      e.target.setAttribute('rel', 'noopener noreferrer');
    }
  });
});
